import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCartH18(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 14.652a.468.468 0 1 0-.937 0 .468.468 0 0 0 .936 0m1.3 0a1.769 1.769 0 1 1-3.538 0 1.769 1.769 0 0 1 3.537 0M12.964 14.652a.468.468 0 1 0-.937.001.468.468 0 0 0 .937-.002m1.3 0a1.769 1.769 0 1 1-3.537 0 1.769 1.769 0 0 1 3.537 0M14.396 3.95c.893 0 1.555.827 1.361 1.699L14.6 10.86a1.395 1.395 0 0 1-1.362 1.091h-7.38A1.396 1.396 0 0 1 4.5 10.875L3.065 4.75a.65.65 0 0 1 .633-.799zm-8.63 6.63c.01.042.048.073.092.073h7.379c.044 0 .084-.031.094-.075l1.158-5.212a.095.095 0 0 0-.093-.115H4.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.575 1.709a1.395 1.395 0 0 1 1.366 1.078l1.173 5.017a.65.65 0 0 1-1.266.296L2.676 3.082a.096.096 0 0 0-.094-.073l-1.41.008a.65.65 0 0 1-.008-1.3z"
  }));
}
var IcCartH18 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCartH18));

export { IcCartH18 as I };
